import type { OperationProgressPhase } from '@foodlista/trigger-vue'

/**
 * FE-side mapping from a semantic phase emitted by a backend operation to a
 * translated user-facing string. Each operation registers its own translator
 * so translations remain a FE concern — the backend never emits locale keys.
 *
 * The mapper receives the raw phase (see `OperationProgressPhase`) and the
 * i18n `t` function; it must return an already-translated string. It should
 * exhaustively handle all `kind`s its operation emits; return `undefined` if
 * a phase is unknown and the row falls back to the status string.
 */
export type OperationProgressTranslator = (
  phase: OperationProgressPhase,
  t: (
    key: string,
    named?: Record<string, unknown>,
    plural?: number,
  ) => string,
) => string | undefined

const translators = new Map<string, OperationProgressTranslator>()

export function registerOperationProgressTranslator(
  operationType: string,
  translator: OperationProgressTranslator,
) {
  translators.set(operationType, translator)
}

export function getOperationProgressTranslator(
  operationType: string,
): OperationProgressTranslator | undefined {
  return translators.get(operationType)
}
